// extracted by mini-css-extract-plugin
module.exports = {"item_part_number":"partNumber_item_part_number__D9era"};